/**
 * src/billing/revenuecat.web.ts — WEB no-op RevenueCat stub.
 *
 * CRITICAL WEB-SAFETY (matches src/platform/linking.web.ts): getabeam.com is this same Expo app
 * exported for web and is LIVE. `react-native-purchases` / `react-native-purchases-ui` are
 * NATIVE-ONLY modules that must NEVER be imported into the web bundle. This file exports the exact
 * same names as `revenuecat.ts` but imports nothing native — Metro picks it for the web platform,
 * so the web export never references the RevenueCat SDK.
 *
 * Every function is a safe no-op: not subscribed, paywall/customer-center resolve without
 * presenting anything. The web checkout path stays on Stripe (the marketing /pricing flow).
 */

export const ENTITLEMENT_ID = 'beam Pro';
export const MONTHLY_PACKAGE_ID = 'monthly';

export type PaywallOutcome = 'purchased' | 'restored' | 'cancelled' | 'not_presented' | 'error';

// Mirror the native CustomerInfo just enough for `isSubscribed`; web never produces one.
export type CustomerInfo = unknown;

export async function configureRevenueCat(_appUserID: string): Promise<void> {
  // no-op on web
}

export async function logInRevenueCat(_appUserID: string): Promise<void> {
  // no-op on web
}

export async function logOutRevenueCat(): Promise<void> {
  // no-op on web
}

export async function getCustomerInfo(): Promise<CustomerInfo | null> {
  return null;
}

export function isSubscribed(_customerInfo: CustomerInfo | null | undefined): boolean {
  return false;
}

export async function presentPaywall(): Promise<PaywallOutcome> {
  return 'not_presented';
}

export async function presentPaywallIfNeeded(): Promise<PaywallOutcome> {
  return 'not_presented';
}

export async function presentCustomerCenter(): Promise<void> {
  // no-op on web
}

export async function restorePurchases(): Promise<{ ok: boolean; subscribed: boolean }> {
  return { ok: false, subscribed: false };
}

export function addCustomerInfoUpdateListener(_cb: (info: CustomerInfo) => void): void {
  // no-op on web
}

/** False on web — native RevenueCat is not available; callers must not present a native paywall. */
export const REVENUECAT_AVAILABLE = false;
